import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/redeems/redeemsActions";
import { useRedeemsUIContext } from "../RedeemsUIContext";

export function RedeemPhoneDialog({ id, show, onHide }) {
  // Redeems UI Context
  const redeemsUIContext = useRedeemsUIContext();
  const redeemsUIProps = useMemo(() => {
    return {
      setIds: redeemsUIContext.setIds,
      queryParams: redeemsUIContext.queryParams,
    };
  }, [redeemsUIContext]);

  // Redeems Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.redeems.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { actionsLoading, redeemForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.redeems.actionsLoading,
      redeemForEdit: state.redeems.redeemForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    // server call for getting Redeem by id
    dispatch(actions.fetchRedeem(id));
  }, [id, dispatch]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  // get admin
  const { user } = useSelector((state) => state.auth);

  const sendPhoneVerificationMail = () => {
    // server request for deleting redeem by id
    dispatch(
      actions.sendPhoneVerificationMail(
        redeemForEdit._id,
        redeemForEdit.redeemUser,
        redeemForEdit.redeemEmail,
        user._id
      )
    ).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchRedeems(redeemsUIProps.queryParams));
      // clear selections list
      redeemsUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {(isLoading || actionsLoading) && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Send Phone Verification Mail
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Would you like to send Phone Verification Mail?</span>
        )}
        {isLoading && <span>Sending ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            close
          </button>
          <> </>
          <button
            type="button"
            onClick={sendPhoneVerificationMail}
            className="btn btn-warning btn-elevate"
          >
            Send Mail
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
